import {clearFeedbacksByName, getInputsByName} from "../../helpers/forms";

function initUserForm(formElement) {
    // init form


    // Form methods
    return {
        formElement,
        formFields: [
            'id',
            'first_name',
            'last_name',
            'email',
            'password',
            'role_id'
        ],
        inputs(){
            return getInputsByName(formElement, this.formFields);
        },
        clearFeedbacks(){
            return clearFeedbacksByName(formElement, this.formFields);
        },
        postUrl() {
            return formElement.dataset.url;
        },
        successUrl() {
            return formElement.dataset.successUrl;
        }
    };
}

export {initUserForm}
